import Dashboard from "@/pages/contributor/Dashboard";
import NotFound from "@/pages/NotFound";
import { Fragment } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Sidebar from "./contributor/Sidebar";
import MyInvoice from "./dialog/contributor/MyInvoice";

const ContributorRoute = () => {
	return (
		<main className="h-screen w-full">
			<Router>
				<Fragment>
					<Sidebar />
					<div className="lg:ml-[300px] grow">
						<div className="p-4">
							<Routes>
								<Fragment>
									<Route path="/" element={<Dashboard />}></Route>
									<Route path="/contributor-invoice/:id" element={<MyInvoice />}></Route>
									<Route path="*" element={<NotFound />} />
								</Fragment>
							</Routes>
						</div>
					</div>
				</Fragment>
			</Router>
		</main>
	);
};

export default ContributorRoute;
